// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "world.ixo",
    name: "Impact Wallet",
    homepage: "https://www.ixo.world/",
    image_id: "afc85418-2ca6-46cf-cfb9-daf6bc43e400",
    app: {
        browser: null,
        ios: "https://apps.apple.com/app/impacts-x/id6444948058",
        android: "https://play.google.com/store/apps/details?id=com.ixo.mobile",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "impactsx://",
        universal: null,
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map